module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copyright-mark"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.name))]), _vm._v(" " + _vm._s(_vm.desc) + " |\n\t\t\t"), _vm._m(0), _vm._v(" |\n\t\t\t"), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "tel:+972525865589",
      "title": "Reach us by phone"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-earphone"
  }), _vm._v(" (972) 52-5865589")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "mailto:info@weboko.co.il",
      "title": "Write us an E-mail"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-envelope"
  }), _vm._v(" E-Mail Us")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29829f05!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/appFooter.vue
// module id = 48
// module chunks = 1